export default __webpack_public_path__ + "static/ai-solutions-with-roadmap2-7a7a81a38d47a7e954f6d4d532e43aef.jpg";